import { AfterViewInit, Component, inject, ViewChild } from '@angular/core';
import { EarhivUiComponents } from '@app/shared/models/earhiv-ui-components';
import { FilterContainerUtil } from '@app/shared/util/filter-container-util';
import { CommonFilterViewComponent } from '@ntap/common';
import { DynamicComponent, FilterViewProviderDirective } from '@ntap/core';
import { PrimeNGCommonListViewComponent } from '@ntap/primeng';

@Component({
  selector: 'app-common-list-grid-view',
  templateUrl: './common-list-grid-view.component.html',
  styleUrls: ['./common-list-grid-view.component.css']
})
export class CommonListGridViewComponent
  extends PrimeNGCommonListViewComponent
  implements AfterViewInit
{
  override tableCompId: string = EarhivUiComponents.TABLE_LIST_GRID_VIEW;

  @ViewChild('filterContainer')
  filterContainer: DynamicComponent;
  filterViewProviderDirective = inject(FilterViewProviderDirective);

  ngAfterViewInit(): void {
    if (this.filterContainer) {
      const filterComponent =
        this.filterContainer.getViewComponent() as CommonFilterViewComponent;
      FilterContainerUtil.separateOsnovnaNaprednaPretraga(filterComponent);
    }
  }

  private clearAndRefetchDefaultFilter(
    filterComponent: CommonFilterViewComponent
  ) {
    filterComponent['dynamicFormService'].clearFormValues();
    filterComponent.clearFilter();
  }
}
